import stylesheet from './ImageCarousel.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import './CarouselPagination';

const ITEM_TAG = 'nxt-image-carousel-item';
const ACTIVE_ATTR = 'active';

class NXTImageCarousel extends CustomComponent {
    currentIndex = 0;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('image-carousel');
        container.innerHTML = `<slot></slot>`;

        const items = this.getItems();
        items.forEach((item, index) => {
            item.toggleAttribute(ACTIVE_ATTR, index === 0);
        });

        this.injectPaginations(items);

        this.addEventListener('carousel-prev', () => this.prev());
        this.addEventListener('carousel-next', () => this.next());

        return container;
    }

    next() {
        this.goTo(this.currentIndex + 1);
    }

    prev() {
        this.goTo(this.currentIndex - 1);
    }

    get countSlides(): number {
        return this.getItems().length;
    }

    goTo(index: number) {
        const items = this.getItems();
        if (items.length < 2) return;

        const nextIndex = Math.max(0, Math.min(index, items.length - 1));
        if (nextIndex === this.currentIndex) return;

        items[this.currentIndex].removeAttribute(ACTIVE_ATTR);
        items[nextIndex].setAttribute(ACTIVE_ATTR, '');
        this.currentIndex = nextIndex;
    }

    getItems(): HTMLElement[] {
        return Array.from(this.querySelectorAll<HTMLElement>(`:scope > ${ITEM_TAG}`));
    }

    private injectPaginations(items: HTMLElement[]) {
        if (items.length < 2) return;

        items.forEach((item, index) => {
            const pagination = document.createElement('nxt-carousel-pagination');
            pagination.setAttribute('slot', 'pagination');
            pagination.setAttribute('size', 'lg');
            pagination.setAttribute('size-lg', 'md');
            pagination.textContent = `${index + 1}/${items.length}`;
            if (index > 0) pagination.setAttribute('has-prev', '');
            if (index < items.length - 1) pagination.setAttribute('has-next', '');
            item.appendChild(pagination);
        });
    }
}

customElements.define('nxt-image-carousel', NXTImageCarousel);
